/**
 * 邀请链接 / 推荐码归因的共享常量与工具（Edge、服务端、客户端通用，不依赖数据库）
 *
 * 规则（见 docs/product/BotGo_Creator_Affiliate_Manual_V0_2026-11-01.md §6.1）：
 * - 任意页面带 ?ref=CODE 访问时写入首方 Cookie，30 天内先到先得
 * - 只有新注册账号在创建时绑定推荐人；注册后 7 天内、首付前可补填推荐码
 * - 注册后 90 天内首次付费才计佣；被推荐人首付赠送 500 月度积分
 */

export const REFERRAL_QUERY_PARAM = 'ref';
export const REFERRAL_COOKIE_NAME = 'bg_ref';
export const REFERRAL_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 30;
export const REFERRAL_CLAIM_WINDOW_DAYS = 7;
export const REFERRAL_ATTRIBUTION_WINDOW_DAYS = 90;
export const REFERRAL_WELCOME_CREDITS = 500;

const REFERRAL_CODE_PATTERN = /^[A-Z0-9_-]{3,20}$/;
const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * 规范化推荐码：去空白、转大写，并校验字符集与长度（与 users.referral_code varchar(20) 一致）
 * @returns {string|null} 合法时返回大写推荐码，否则返回 null
 */
export function normalizeReferralCode(value) {
  if (typeof value !== 'string') return null;
  const normalized = value.trim().toUpperCase();
  return REFERRAL_CODE_PATTERN.test(normalized) ? normalized : null;
}

/**
 * 从 Cookie 请求头中读取推荐码（用于没有 NextRequest.cookies 的场景）
 */
export function readReferralCodeFromCookieHeader(cookieHeader) {
  if (typeof cookieHeader !== 'string' || !cookieHeader) return null;
  const match = cookieHeader.match(new RegExp(`(?:^|;\\s*)${REFERRAL_COOKIE_NAME}=([^;]+)`));
  if (!match) return null;
  try {
    return normalizeReferralCode(decodeURIComponent(match[1]));
  } catch {
    return null;
  }
}

/**
 * 生成用户的邀请链接
 */
export function buildReferralLink(origin, code) {
  const normalized = normalizeReferralCode(code);
  if (!normalized) return null;
  const url = new URL('/', origin);
  url.searchParams.set(REFERRAL_QUERY_PARAM, normalized);
  return url.toString();
}

/**
 * 判断某个时间点是否仍在“注册后 N 天”窗口内
 */
export function isWithinDaysOf(start, days, now = Date.now()) {
  const startMs = start instanceof Date ? start.getTime() : new Date(start).getTime();
  if (!Number.isFinite(startMs)) return false;
  return now - startMs <= days * DAY_MS;
}
